export enum LargeMessageTheme {
  GOLD,
  BLUE,
  GREEN
}
